// extracted by mini-css-extract-plugin
export default {"card":"AllResidents_card__IOf66","cardImage":"AllResidents_cardImage__lekQF","cardText":"AllResidents_cardText__dPvx1"};